import { Image } from "./image";
import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export const Gallery = (props) => {
  const settings = {
    dots: false,
    infinite: props.data && props.data.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "0px",

  };

  return (
    <div id="portfolio" className="text-center" style={{ maxHeight: "800px" }}>
      <div className="container">
        <div className="section-title">
          <h2>Projects</h2>
        </div>
        <div className="row">
          {props.data && props.data.length > 0 ? (
            <Slider {...settings}>
              {props.data.map((d, i) => (
                <div key={`${d.title}-${i}`} style={{ padding: "0 10px" }}>
                  <Image
                    title={d.title}
                    largeImage={d.largeImage}
                    smallImage={d.smallImage}
                    mediumUrl={d.mediumUrl}
                  />
                </div>
              ))}
            </Slider>
          ) : (
            "Loading..."
          )}
        </div>
      </div>
    </div>
  );
};
